import { Group, Title } from "@mantine/core";
import type { FC, PropsWithChildren, ReactNode } from "react";

export type PageTitleProps = PropsWithChildren<{}> & {
    title?: ReactNode;
};

const PageTitle: FC<PageTitleProps> = ({ title, children }) => {
    return (
        <Group justify="space-between" align="flex-start">
            <Title order={2}>{title}</Title>
            {children && (
                <Group justify="flex-end" gap="xs">
                    {children}
                </Group>
            )}
        </Group>
    );
};

export default PageTitle;
